import * as React from "react";

import { ILazyLoadingManager } from "../Engine/Core/LazyLoading/LazyLoadingManager";

import { useFormObject } from "./FormObjectProvider";
import { createHocDisplayName } from "./TypingUtils";

interface WithLazyLoadingManagerInjectableProps {
    lazyLoadingManager: ILazyLoadingManager;
}

export function withLazyLoadingManager<P extends WithLazyLoadingManagerInjectableProps>(
    WrappedComponent: React.ComponentType<P & WithLazyLoadingManagerInjectableProps>
): React.ComponentType<Omit<P, "lazyLoadingManager">> {
    function WithLazyLoadingManager(props: Omit<P, "lazyLoadingManager">): JSX.Element {
        const form = useFormObject();

        // @ts-ignore Баг с HOC-ами https://github.com/Microsoft/TypeScript/issues/28938
        const newProps: P = {
            ...props,
            lazyLoadingManager: form.lazyLoadingManager,
        };

        return <WrappedComponent {...newProps} />;
    }
    WithLazyLoadingManager.displayName = createHocDisplayName(WrappedComponent, "LazyLoadingManager");
    return WithLazyLoadingManager;
}
